import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import cn from "classnames";
import { useState } from "react";

import { CrossIcon, SearchIcon } from "components/Icons";

import styles from "./styles.module.scss";

type Props = {
  onChange: (val: string) => void;
  value: string;
  autoFocus?: boolean;
  noBorder?: boolean;
  size?: "mini" | "small" | "regular";
  placeholder?: string;
  testId?: string;
  className?: string;
  disabled?: boolean;
  autoComplete?: string;
};

export const useSearchHandlers = () => {
  const [search, setSearch] = useState("");

  const onChange = (value: string) => {
    setSearch(value);
  };
  return {
    search,
    onChange,
  };
};

export const Search = (props: Props) => {
  const {
    onChange,
    value,
    autoFocus,
    size = "regular",
    placeholder = "Search",
    testId,
    noBorder,
    className,
    disabled,
    autoComplete = "off",
  } = props;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
    const value = event.target.value;
    onChange(value);
  };

  const reset = () => {
    onChange("");
  };

  return (
    <div
      className={cn(styles.search, className, {
        [styles.small]: size === "small",
        [styles.mini]: size === "mini",
        [styles.noBorder]: noBorder,
        [styles.searchDisabled]: disabled,
      })}
    >
      <TextField
        classes={{
          root: styles.root,
        }}
        autoFocus={autoFocus}
        variant="outlined"
        size="small"
        placeholder={placeholder}
        onChange={handleChange}
        value={value}
        disabled={disabled}
        autoComplete={autoComplete}
        slotProps={{
          input: {
            classes: {
              root: styles.inputContainer,
            },
            endAdornment: (
              <InputAdornment
                classes={{ root: styles.iconContainer }}
                position="end"
                disablePointerEvents={!value}
                onClick={reset}
              >
                {value ? <CrossIcon /> : <SearchIcon />}
              </InputAdornment>
            ),
          },
          htmlInput: {
            "data-testid": testId,
          },
        }}
      />
    </div>
  );
};
